export default __webpack_public_path__ + "static/alice_k106-5f1b27caab083cecbdbe8b783d854918.jpg";